export const ConsumerAddressViewUat = {
  title: 'workflow.consumerAddress.title',
}
